import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { Affiliate } from '@/models/affiliate';

export const fetchAffiliate = async (codeName: string): Promise<Affiliate> => {
  const response = await queryExecute({
    query: graphql(`
      query Affiliate($codeName: String, $extension: Float, $id: Float) {
        affiliate(codeName: $codeName, extension: $extension, id: $id) {
          id
          name
          codeName
          extension
          promoCode
          phoneNumber
          gogoNumber
          email
          streetAddress
          streetAddress2
          city
          state
          zip
          country
          latitude
          longitude
          currency
          timeZone
          description
          isDisabled
          logoUrl
        }
      }
    `),
    variables: {
      codeName,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.affiliate!;
};
